import React from 'react'
import {getResizedImageSSR_image} from '@data/queries/components/__generated__/getResizedImageSSR'
import useResizedImageUrlSsr from '@hooks/useResizedImageUrlSsr.main'

import styles from './styles.module.css'

export default function Image(props: {file?: {_id: string}; ssrImage?: getResizedImageSSR_image}) {
  const {file} = props
  const queriedUrl = useResizedImageUrlSsr({
    fileId: file ? file._id : null,
    width: 500,
    height: 300
  })

  const url = queriedUrl ? queriedUrl : props.ssrImage?.resizedURL

  if (!file) return null

  return <img className={styles.image} src={url} alt="" />
}
